import { useState } from 'react';
import { useSongs } from '@/context/SongContext';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Check, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export default function TextEditor({ songId, onComplete }) {
    const { addFragment } = useSongs();
    const [content, setContent] = useState('');
    const [label, setLabel] = useState('');
    const [saving, setSaving] = useState(false);

    const handleSave = async () => {
        if (!content.trim()) {
            toast.error('Please write something first');
            return;
        }

        setSaving(true);
        try {
            const fragment = await addFragment(songId, {
                type: 'text',
                label: label || 'Note',
                content: content.trim()
            });

            toast.success('Text saved');
            onComplete(fragment?.id);
        } catch (error) {
            console.error('Error saving text:', error);
            toast.error('Failed to save text');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="space-y-4 max-w-lg mx-auto">
            <div className="space-y-2">
                <Label htmlFor="label">Label (optional)</Label>
                <Input
                    id="label"
                    value={label}
                    onChange={(e) => setLabel(e.target.value)}
                    placeholder="e.g., Verse 1, Chorus, Bridge idea"
                    className="hover:border-primary/50 transition-colors"
                />
            </div>

            <div className="space-y-2">
                <Label htmlFor="content">Content</Label>
                <Textarea
                    id="content"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    placeholder="Write lyrics, notes, thoughts, ideas...

This is your space. No judgment, no pressure. 
Just words waiting to become something."
                    className="min-h-[200px] resize-none font-body hover:border-primary/50 transition-colors"
                    autoFocus
                />
            </div>

            <Button
                onClick={handleSave}
                disabled={saving || !content.trim()}
                className="w-full h-12 hover:scale-[1.02] active:scale-[0.98] transition-transform"
            >
                {saving ? (
                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                ) : (
                    <Check className="w-4 h-4 mr-2" />
                )}
                Save Text
            </Button>
        </div>
    );
}